<template>
	<section id="secure-buying" class="sg-section" style="background: linear-gradient(135deg, #1a1a1a, #2c2416);">
		<v-container>
			<h2 class="sg-section-title white--text">چگونه خرید طلا آنلاین امن و مطمئن داشته باشیم؟</h2>
			<div class="sg-gold-line"></div>
			<p class="sg-section-subtitle" style="color: rgba(255,255,255,0.6);">
				راهنمای گام‌به‌گام خرید امن طلا از {{ businessTitle }}
			</p>

			<v-row>
				<v-col v-for="(step, i) in steps" :key="i" cols="12" sm="6" md="3">
					<div class="sg-secure-step">
						<div class="sg-secure-step-num">{{ i + 1 }}</div>
						<v-icon color="#D4AF37" size="36" class="mb-3">{{ step.icon }}</v-icon>
						<h3 class="white--text font-weight-bold mb-2" style="font-size: 1rem;">{{ step.title }}</h3>
						<p style="color: rgba(255,255,255,0.65); font-size: 0.85rem; line-height: 1.8;">{{ step.desc }}</p>
					</div>
				</v-col>
			</v-row>

			<v-row justify="center" class="mt-8">
				<v-col cols="12" md="8">
					<v-alert
						color="rgba(201, 162, 39, 0.15)"
						border="left"
						colored-border
						border-color="#C9A227"
						class="mb-0"
					>
						<div class="d-flex align-center">
							<v-icon color="#D4AF37" class="ml-3">mdi-shield-lock</v-icon>
							<span style="color: rgba(255,255,255,0.85); font-size: 0.9rem;">
								تمامی معاملات در {{ businessTitle }} با فاکتور رسمی، گواهی اصالت و بیمه ارسال انجام می‌شود.
								در صورت هرگونه ابهام، تیم پشتیبانی ما ۲۴ ساعته در خدمت شماست.
							</span>
						</div>
					</v-alert>
				</v-col>
			</v-row>
		</v-container>
	</section>
</template>

<script>
	import { get } from 'vuex-pathify'

	export default {
		name: 'SecureBuyingSection',
		computed: {
			...get('appSettings', ['landingSettings']),
			...get('siteConfig', ['fullTitle']),
			businessTitle() {
				return this.landingSettings?.businessTitle || this.fullTitle || 'طلای سیف زاده'
			},
		},
		data() {
			return {
				steps: [
					{
						icon: 'mdi-magnify',
						title: 'انتخاب و بررسی',
						desc: 'محصول مورد نظر را انتخاب کنید. وزن، اجرت و قیمت نهایی را بررسی کنید.',
					},
					{
						icon: 'mdi-clipboard-check',
						title: 'ثبت سفارش',
						desc: 'فرم سفارش را تکمیل کنید. مشخصات و نوع خرید (نقدی یا قسطی) را مشخص نمایید.',
					},
					{
						icon: 'mdi-credit-card-check',
						title: 'پرداخت امن',
						desc: 'از درگاه‌های پرداخت معتبر و امن استفاده کنید. فاکتور رسمی صادر می‌شود.',
					},
					{
						icon: 'mdi-truck-check',
						title: 'دریافت و تایید',
						desc: 'محصول بیمه‌شده ارسال می‌شود. اصالت طلا را با گواهی دریافتی تایید کنید.',
					},
				],
			}
		},
	}
</script>
